import React from 'react';
import ReactDOM from 'react-dom';
import './popLayer.scss';

function classNames(a, b) {
    return ((a ? a : '') + ' ' + (b ? b : "")).trim();
}

class RenderLayer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.mountLayer();
    }

    componentWillUnmount() {
        this.unmountLayer();
    }

    mountLayer() {
        this.body = document.querySelector('body');
        this.bodyOverflow = this.body.style.overflow;
        this.body.style.overflow = 'hidden';
        this._layer = document.createElement('div');
        this._layer.className = classNames('pubhub-agenda-poplayer-container', this.props.className);
        document.body.appendChild(this._layer);
    }

    unmountLayer() {
        this.body.style.overflow = this.bodyOverflow;
        document.body.removeChild(this._layer);
    }

    render() {
        return ReactDOM.createPortal(this.props.children, this._layer)
    }
}


export default class PopLayer extends React.Component {
    render() {
        let className = classNames('pubhub-agenda-poplayer', this.props.className);
        let overlayClass = classNames('pubhub-agenda-poplayer-overlay', this.props.overlayClassName);

        return (
            <RenderLayer className={this.props.hostClassName}>
                <div className={className}>
                    <div className={overlayClass} onClick={this.props.onClickAway}></div>
                    {this.props.children}
                </div>
            </RenderLayer>
        );
    }
}
